import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { KidAvatar, OPTIONS, DEFAULT_AVATAR } from "@/components/live/KidAvatar";

const LABELS = { skin: "Skin", hair: "Hair", hair_color: "Hair color", eyes: "Eyes", shirt: "Shirt", accessory: "Extra", bg: "Background" };
const isColor = (v) => v.startsWith("#");

export const AvatarDesigner = ({ initial, onSaved, onPick, hideSave }) => {
  const [a, setA] = useState(initial || DEFAULT_AVATAR);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { onSaved((await http.put("/live/avatar", a)).data.avatar); toast.success("Avatar saved!"); }
    catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <div className="grid md:grid-cols-12 gap-8 items-start" data-testid="avatar-designer">
      <div className="md:col-span-4 flex flex-col items-center gap-4">
        <KidAvatar a={a} className="w-48 h-48 drop-shadow-xl" testId="avatar-preview" />
        {!hideSave && <button onClick={save} disabled={busy} data-testid="avatar-save-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#2C4A3E] text-white disabled:opacity-60">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Save my avatar</button>}
        <p className="text-xs text-stone-500 text-center max-w-[220px]">Cartoon avatars keep you private online. Never share your real photo.</p>
      </div>
      <div className="md:col-span-8 space-y-4">
        {Object.entries(OPTIONS).map(([k, opts]) => (
          <div key={k}>
            <p className="text-xs uppercase tracking-widest text-stone-500 mb-2">{LABELS[k]}</p>
            <div className="flex flex-wrap gap-2">
              {opts.map((o) => (
                <button type="button" key={o} onClick={() => { const n = { ...a, [k]: o }; setA(n); onPick?.(n); }} data-testid={`avatar-${k}-${o.replace("#", "")}`} aria-label={`${LABELS[k]} ${o}`}
                  className={`transition-transform hover:scale-110 ${a[k] === o ? "ring-2 ring-offset-2 ring-[#2C4A3E]" : ""} ${isColor(o) ? "w-8 h-8 rounded-full" : "px-3 py-1.5 rounded-full text-xs bg-white border border-[#E6DEC3] capitalize"}`}
                  style={isColor(o) ? { background: o } : undefined}>{isColor(o) ? "" : o}</button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
